import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicWhyHostInfoBlock && values.dynamicWhyHostInfoBlock.length > 0) {
    const dynamicWhyHostInfoBlockErrors = [];
    values.dynamicWhyHostInfoBlock.forEach((item, index) => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item.earnBlockTitle1) {
        itemErrors.earnBlockTitle1 = messages.required;
      } else if (item.earnBlockTitle1.trim() == "") {
        itemErrors.earnBlockTitle1 = messages.required;
      } else if (item.earnBlockTitle1 && item?.earnBlockTitle1?.length > inputTextLimit) {
        itemErrors.earnBlockTitle1 = messages.inputTextLimitError;
      }

      if (!item.earnBlockContent1) {
        itemErrors.earnBlockContent1 = messages.required;
      } else if (item.earnBlockContent1.trim() == "") {
        itemErrors.earnBlockContent1 = messages.required;
      } else if (item.earnBlockContent1 && item?.earnBlockContent1?.length > inputDescLimit) {
        itemErrors.earnBlockContent1 = messages.inputDescLimitError;
      }

      if (Object.keys(itemErrors).length > 0) {
        dynamicWhyHostInfoBlockErrors[index] = itemErrors;
      }
    });

    if (dynamicWhyHostInfoBlockErrors.length > 0) {
      errors.dynamicWhyHostInfoBlock = dynamicWhyHostInfoBlockErrors;
    }
  }

  return errors
}

export default validate;